Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShareUrl = void 0;
var getShareUrl = exports.getShareUrl = function getShareUrl(organizations, campaigns) {
  if (!organizations || organizations.length === 0) return undefined;
  if (organizations.length === 1) {
    var _organizations$;
    return (_organizations$ = organizations[0]) == null ? void 0 : _organizations$.shareUrl;
  } else {
    var _campaigns$;
    var campaignOrganizationId = campaigns == null ? void 0 : (_campaigns$ = campaigns[0]) == null ? void 0 : _campaigns$.organizationId;
    if (campaignOrganizationId) {
      var _organizations$find;
      return (_organizations$find = organizations.find(function (org) {
        return org.id === campaignOrganizationId;
      })) == null ? void 0 : _organizations$find.shareUrl;
    } else {
      var _organizations$2;
      return organizations == null ? void 0 : (_organizations$2 = organizations[0]) == null ? void 0 : _organizations$2.shareUrl;
    }
  }
};